import script from "./AuthSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSlider.vue?vue&type=script&setup=true&lang=js"

import "./AuthSlider.vue?vue&type=style&index=0&id=5995e66f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5995e66f"]])

export default __exports__